import { render, staticRenderFns } from "./HealthReportListItem.vue?vue&type=template&id=167abcec&scoped=true"
import script from "./HealthReportListItem.vue?vue&type=script&lang=ts"
export * from "./HealthReportListItem.vue?vue&type=script&lang=ts"
import style0 from "./HealthReportListItem.vue?vue&type=style&index=0&id=167abcec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167abcec",
  null
  
)

export default component.exports